<template>
  <div>
    <h1>{{ $t("sidebar.voucher") }}</h1>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <div>
      <b-button v-b-toggle.collapse-1 variant="primary">Gerar novo</b-button>

      <b-collapse id="collapse-1" class="mt-2">
        <VoucherCrud @refresh-table="refreshTable"></VoucherCrud>
      </b-collapse>
    </div>
    <b-table
      ref="voucherTable"
      :busy.sync="isBusy"
      :items="tableProvider"
      :fields="fields"
      :filter="filter"
      :filter-debounce="600"
      :per-page="tablePerPage"
      :current-page="tableCurrentPage"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      striped
      hover
    >
      <template #thead-top>
        <b-tr>
          <b-th
            v-for="field in fields"
            :key="field.filterKey"
            class="vertical-align"
          >
            <div v-if="field.key != 'actions'">
              <b-form-input
                v-if="field.key == 'expirationDate'"
                v-model="filter[field.key]"
                :placeholder="'Buscar por ' + field.label"
                class="idStyle"
                v-mask="'dd/MM/yyyy'"
                type="date"
              />
              <b-form-select
                v-else-if="field.key == 'type'"
                v-model="filter[field.key]"
                :options="typeOpt"
              />
              <b-form-select
                v-else-if="field.key == 'userCreated'"
                v-model="filter[field.key]"
                :options="userOpt"
              />
              <b-form-select
                v-else-if="field.key == 'status'"
                v-model="filter[field.key]"
                :options="statusOpt"
              />
              <b-form-input
                v-else
                v-model="filter[field.key]"
                :placeholder="'Buscar por ' + field.label"
                class="idStyle"
              />
            </div>
          </b-th>
        </b-tr>
      </template>
      <template v-slot:cell(code)="data">
        <b-button
          class="cargo-data-row"
          @click="copyCode(data.item.code)"
          variant="link"
          >{{ data.item.code }}</b-button
        >
      </template>
      <template v-slot:cell(actions)="data">
        <b-button size="sm" @click="openModal(data.item.id)">Detalhes</b-button>
      </template>
    </b-table>
    <table-pagination
      :currentPage.sync="tableCurrentPage"
      :pageOptions.sync="tablePageOptions"
      :rowCount.sync="tableRowCount"
      :perPage.sync="tablePerPage"
    />
    <VoucherDatailModal :isOpen.sync="showModal" :voucherId="voucherId">
    </VoucherDatailModal>
  </div>
</template> 

<script>
import AwesomeMask from "awesome-mask";
export default {
  name: "VoucherInit",
  components: {
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    TablePagination: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
    VoucherCrud: () =>
      import("@/components_rms/System/Voucher/VoucherCrud.vue"),
    VoucherDatailModal: () =>
      import("@/components_rms/System/Voucher/VoucherDetailModal.vue"),
  },
  directives: {
    mask: AwesomeMask,
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Código copiado com sucesso",
      },
      showModal: false,
      sortBy: "id",
      sortDesc: false,
      isBusy: false,
      voucherId: 0,
      fields: [
        {
          key: "actions",
          label: "",
          tdClass: "actions",
          thStyle: "width: 50px",
        },
        {
          key: "code",
          label: "Código",
          tdClass: "code",
          thStyle: "width: 100px",
        },
        {
          key: "expirationDate",
          label: "Data de Expiração",
          tdClass: "expirationDate",
          thStyle: "width: 100px",
        },
        {
          key: "type",
          label: "Tipo",
          tdClass: "type",
          thStyle: "width: 100px",
        },
        {
          key: "status",
          label: "Status",
          tdClass: "status",
          thStyle: "width: 100px",
        },
      ],
      typeOpt: [
        { value: 0, text: "Todos" },
        { value: 1, text: "Desconto" },
        { value: 2, text: "Preenchimento" },
        { value: 3, text: "Veículos" },
      ],
      statusOpt: [
        { value: "Ativo", text: "Ativo" },
        { value: "Expirado", text: "Expirado" },
      ],
      filter: {
        code: "",
        expirationDate: "",
        type: 0,
        UserCreatedId: 0,
        amount: 0,
        status: "Ativo",
      },
      userOpt: [],
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableRowCount: 0,
    };
  },
  methods: {
    openModal(itemId) {
      this.showModal = true;
      this.voucherId = itemId;
    },
    copyCode(code) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(code)
          .then(() => {
            this.$refs.alert.show();
          })
          .catch((err) => {
            console.error("Erro ao copiar: ", err);
          });
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = code;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand("copy");
          this.$refs.alert.show();
        } catch (err) {
          console.error("Erro ao copiar: ", err);
        }
        document.body.removeChild(textArea);
      }
    },
    getRmsUser() {
      this.$apiScheduler
        .get("/v1/user/company/dropdownOptions")
        .then((response) => {
          this.userOpt = response.data;
        });
    },
    tableProvider(ctx, callback) {
      this.isBusy = true;

      let apiFilter = {
        code: ctx.filter.code,
        expirationDate: ctx.filter.expirationDate,
        type: ctx.filter.type,
        UserCreatedId: 0,
        amount: 0,
        status: ctx.filter.status,
        perPage: ctx.perPage,
        currentPage: ctx.currentPage,
      };
      this.$apiScheduler
        .post("/voucher/getAll", apiFilter)
        .then((response) => {
          this.tableRowCount = response.data.totalItems;
          this.isBusy = false;
          this.items = response.data.items;
          callback(this.items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
              this.isBusy = false;
            });
          } else {
            this.tableIsBusy = false;
            this.tableRowCount = 0;
            this.isBusy = false;
            callback([]);
          }
        });
      return null;
    },
    refreshTable() {
      this.$refs.voucherTable.refresh();
    },
  },
  mounted() {
    this.getRmsUser();
  },
};
</script>

<style scoped>
.cargo-data-row {
  color: #c0c1c2;
}
</style>